<template>
  <div class="banner">
    <div class="info">
      <div class="title">
        <span>402</span>
        <span>厨神菜单</span>
      </div>
    </div>
    <div class="art">
      <img src="../assets/banner.jpg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderBanner'
}
</script>

<style scoped>
.banner {
  display: flex;
  align-items: center;
  height: 96px;
  background: #f7ede7;
  overflow: hidden;
}

.info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 12px 0 18px;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: #5c4a3f;
}

.title span {
  line-height: 1.4;
}

.art {
  flex: 0 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.art img {
  display: block;
  height: 100%;
  width: auto;
  /* 左边缘渐变透明，与米粉色背景自然过渡，消除硬分割线 */
  -webkit-mask-image: linear-gradient(to right, transparent 0%, #000 28%);
  mask-image: linear-gradient(to right, transparent 0%, #000 28%);
}
</style>
